<!--
  ~ Copyright (C) 2022 Pitagon., JSC. - All Rights Reserved.
  ~
  ~ Unauthorized copying or redistribution of this file in source and binary forms via any medium
  ~ is strictly prohibited.
  -->

<a *ngIf="isLink(item) && !isFunction(item.route)"
   [fragment]="item.fragment"
   [routerLinkActiveOptions]="item.routerLinkActiveOptions || { exact: false }"
   [routerLink]="item.route"
   class="ngx-pids-sidenav-item"
   matRipple
   matRippleColor="var(--sidenav-item-ripple-color)"
   routerLinkActive="ngx-pids-sidenav-item--active">
  <mat-icon *ngIf="level === 0" [svgIcon]="item.icon" class="ngx-pids-sidenav-item__icon"></mat-icon>
  <span class="ngx-pids-sidenav-item__label">{{ item.label }}</span>
  <span *ngIf="item.badge"
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
        class="ngx-pids-sidenav-item__badge">{{ item.badge.value }}</span>
</a>

<div (click)="item.route()"
     *ngIf="isLink(item) && isFunction(item.route)"
     class="ngx-pids-sidenav-item"
     matRipple
     matRippleColor="var(--sidenav-item-ripple-color)"
     routerLinkActive="ngx-pids-sidenav-item--active">
  <mat-icon *ngIf="level === 0" [svgIcon]="item.icon" class="ngx-pids-sidenav-item__icon"></mat-icon>
  <span class="ngx-pids-sidenav-item__label">{{ item.label }}</span>
  <span *ngIf="item.badge"
        [ngClass]="[item.badge.bgClass, item.badge.textClass]"
        class="ngx-pids-sidenav-item__badge">{{ item.badge.value }}</span>
</div>

<ng-container *ngIf="isDropdown(item)">
  <div (click)="toggleOpen()"
       [class.ngx-pids-sidenav-item--active]="isOpen || isActive"
       [class.ngx-pids-sidenav-item--open]="isOpen"
       class="ngx-pids-sidenav-item"
       matRipple
       matRippleColor="var(--sidenav-item-ripple-color)">
    <mat-icon *ngIf="level === 0" [svgIcon]="item.icon" class="ngx-pids-sidenav-item__icon"></mat-icon>
    <span class="ngx-pids-sidenav-item__label">{{ item.label }}</span>
    <span *ngIf="item.badge"
          [ngClass]="[item.badge.bgClass, item.badge.textClass]"
          class="ngx-pids-sidenav-item__badge">{{ item.badge.value }}</span>
    <mat-icon class="ngx-pids-sidenav-item__dropdown-icon" svgIcon="mat:keyboard_arrow_right"></mat-icon>
  </div>
  <div [@dropdown]="isOpen" class="ngx-pids-sidenav-item__dropdown">
    <ngx-pids-sidenav-item *ngFor="let subItem of item.children" [item]="subItem"
                           [level]="level + 1"></ngx-pids-sidenav-item>
  </div>
</ng-container>


<ng-container *ngIf="isSubheading(item)">
  <div class="ngx-pids-sidenav-subheading">{{ item.label }}</div>
  <ngx-pids-sidenav-item *ngFor="let subItem of item.children" [item]="subItem" [level]="0"></ngx-pids-sidenav-item>
</ng-container>

